import useUser from "./useUser";
import useMoodboards from "./moodboardData/useMoodboards";

const useData = () => {
  const user = useUser();
  const moodboards = useMoodboards(user);
  return { moodboards, user };
};

export default useData;
